import { render, staticRenderFns } from "./TableOfOffers.vue?vue&type=template&id=b452821a&scoped=true&"
import script from "./TableOfOffers.vue?vue&type=script&lang=js&"
export * from "./TableOfOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b452821a",
  null
  
)

export default component.exports